import initHelpers from '72cms-ui/helpers';
import env from '../../cms/js/config/base';

export default initHelpers(env);
